<template>
  <div class="sidebar">
    <div class="avatar">
      <div
        class="content-bg"
        :class="{editBg:!editAvatarBool}"
        @mouseover="editAvatarBool=true"
        @mouseout="editAvatarBool=false"
      >
        <el-upload
          class="upload-demo"
          style="float:left"
          auto-upload
          name="image"
          :before-upload="beforeUpload"
          :with-credentials="true"
          :show-file-list="false"
          :http-request="upload"
          accept=".jpg, .png"
          :action="varHost + 'uc/update/avatar'"
        >
          <span class="editAvatar" slot="trigger" v-show="editAvatarBool">修改头像</span>
        </el-upload>
        <span class="backEdit" v-show="editAvatarBool" @click="logOutFn()">退出</span>
        <img
          src="../../assets/images/Default_UserPhoto.png"
          alt="用户头像"
          ref="avatar"
          class="avatar-img"
          v-show="avatarShow"
        />
      </div>
      <div class="nickName" :class="{showNick:!eidtNick}">
        <span class="nickName_text" v-if="!eidtNick">
          <i class="edit-icon" @click="changeNameFn(event)"></i>
          {{userInfo.name}}
        </span>
        <input
          type="text"
          maxlength="12"
          @blur="changeNameFn(event)"
          @keyup.enter="changeNameFn()"
          ref="nickName"
          v-model.trim="userInfo.name"
          class="nickName_text"
          v-else
        />
      </div>
    </div>
    <div class="content-list">
      <ul class="list">
        <router-link tag="li" :to="{name:'accBind'}" active-class="active">
          <i class="icon accBind"></i>账号绑定
        </router-link>
        <router-link
          tag="li"
          :to="{name:'safetyCenter'}"
          active-class="active"
          @click.native="showList1=!showList1"
          :class="{showList1:showList1}"
        >
          <i class="icon safetyCenter"></i>安全中心
          <ul class="sub-menu" v-show="showList1" @click.stop>
            <router-link tag="li" to="/index/safetyCenter/changePwd" active-class="active" exact>
              <i class="sub-icon changePwd"></i><span v-if="haspassword">修改密码</span><span v-else>设置密码</span>
            </router-link>

            <router-link
              tag="li"
              to="/index/safetyCenter/realNameCheck"
              active-class="active"
              exact
            >
              <i class="sub-icon realNameCheck"></i>实名认证
            </router-link>

            <router-link tag="li" to="/index/safetyCenter/cancelAcc" active-class="active" exact>
              <i class="sub-icon cancelAcc"></i>注销账号
            </router-link>
          </ul>
        </router-link>
        <router-link tag="li" :to="{name:'menberCenter'}" active-class="active" exact>
          <i class="icon menberCenter"></i>会员中心
        </router-link>
        <!-- <router-link tag="li" :to="{name:'commentMan'}">
          <i class="icon commentMan"></i>评论管理
        </router-link>-->
      </ul>
    </div>
  </div>
</template>

<script>
import user from "@/api/user";
export default {
  name: "sidebar",
  components: {},
  data() {
    return {
      eidtNick: false,
      showList1: true,
      editAvatarBool: false,
      haspassword: false,
      oldNickName: "",
      imageUrl: "",
      avatarShow: true
    };
  },
  computed: {},
  methods: {
    // 文件大小限制
    beforeUpload (file) {
        let types = ['image/jpeg', 'image/gif', 'image/bmp', 'image/png'];
        const isImage = types.includes(file.type);
        const isLtSize = file.size / 1024 / 1024 < 5;
        if (!isImage) {
          this.$Message.error('上传图片只能是 JPG、GIF、BMP、PNG 格式!');
          return false;
        }
        if (!isLtSize) {
          this.$Message.error('上传图片大小不能超过 5MB!');
          return false;
        }
        return true;
    },
    // 自定义文件上传的方式
    upload(item) {
      let formData = new FormData();
      formData.append("image", item.file);
      user
        .changeAvatar(formData)
        .then(res => {
          if (res.status == 200) {
            this.$Message.success("上传完成，请等待审核");
          }
          // this.img_url = res.msg;
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkNickName() {
      if (this.userInfo.name == "" || this.userInfo.name.length > 10) {
        this.$Message("昵称格式不合法！", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
        return false;
      } else {
        return true;
      }
    },
    logOutFn() {
      this.$MessageBox
        .confirm("确定要退出当前账户？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
        .then(() => {
          user
            .logOut()
            .then(res => {
              this.$router.push({ name: "login" });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(action => {
          console.log(action);
        });
    },
    changeNameFn(event) {
      if (this.eidtNick) {
        if (this.oldNickName == this.userInfo.name) {
          this.eidtNick = false;
          return false;
        } else if (this.userInfo.name == "") {
          this.$Message.error("不可使用空昵称～");
          this.userInfo.name = this.oldNickName;
          this.eidtNick = false;
          return false;
        } else {
          //前端防xss攻击过滤
          if (this.filterXSS(this.userInfo.name)) {
            user
              .changeName({ name: this.userInfo.name })
              .then(res => {
                this.$Message.success("修改成功！");
                this.eidtNick = false;
              })
              .catch(err => {
                if (typeof err == "string") {
                  if (err == "名称已经存在。") {
                    this.$Message.error("该昵称已存在，请修改后再次尝试");
                  } else {
                    this.$Message.error("昵称包含敏感词，修改失败");
                  }
                  this.userInfo.name = this.oldNickName;
                }
              });
          } else {
            this.$Message.error('昵称不可使用"&"、"<"、">"、""等字符');
            this.userInfo.name = this.oldNickName;
            this.eidtNick = false;
          }
        }
      }
      this.eidtNick = !this.eidtNick;
      if (this.eidtNick && event) {
        this.$nextTick(() => {
          this.$refs.nickName.focus();
        });
        this.oldNickName = this.userInfo.name;
      }
    },
    filterXSS(str) {
      var compareStr = str;
      var bool = false;
      compareStr ==
      str
        .replace(/&/g, "&amp;")
        .replace(/ /g, "&nbsp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/\r{0,}\n/g, "<br/>")
        ? (bool = true)
        : true;
      return bool;
    }
  },
  created() {
  },
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  watch: {
    userInfo: {
      handler(newVal, oldVal) {
        this.userInfo.avatar
          ? (this.$refs.avatar.src = this.userInfo.avatar)
          : true;
        this.avatarShow = true;
        this.haspassword = newVal.hasPassword
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    }
  },
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>
//组件样式
.sidebar {
  min-height: 650px;
  width: 240px;
  float: left;
  background-color: #fff;
  .avatar {
    height: 230px;
    position: relative;
    .editBg {
      background-color: #ffffff !important;
    }
    .content-bg {
      height: 150px;
      width: 120px;
      border-radius: 10px 10px 60px 60px;
      background-color: #f3f2f0;
      position: absolute;
      left: 60px;
      top: 16px;
      span {
        color: #4981f2;
        font-size: 12px;
        line-height: 14px;
        height: 14px;
        cursor: pointer;
        text-align: center;
        float: left;
        margin-top: 14px;
      }
      .editAvatar {
        width: 70px;
      }
      .backEdit {
        width: 49px;
        border-left: 1px solid #ccc;
      }
      .avatar-img {
        border-radius: 56px;
        border: 6px solid #f2f2f2;
        width: 100px;
        height: 100px;
        position: absolute;
        bottom: 4px;
        left: 4px;
      }
    }
    .nickName {
      width: 195px;
      background-color: #f3f2f0;
      position: absolute;
      bottom: 30px;
      left: 25px;
      height: 30px;
      border-radius: 15px;
      text-align: center;
      .nickName_text {
        padding: 0 24px;
        position: relative;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        line-height: 30px;
        height: 30px;
        display: inline-block;
        border: none;
        background-color: #f3f2f0;
        outline: none;
        text-align: center;
      }
      .edit-icon {
        width: 12px;
        height: 12px;
        position: absolute;
        right: 12px;
        top: 9px;
        background: url("../../assets/images/icons.png") no-repeat -141px -21px;
        cursor: pointer;
      }
    }
    .showNick {
      background-color: #fff;
      .nickName_text {
        background-color: #fff;
      }
    }
  }
  .content-list {
    ul.list {
      padding: 0;
      border-bottom: 1px solid #f3f2f0;
      cursor: pointer;
      > li {
        // height: 50px;
        line-height: 59px;
        font-size: 16px;
        text-align: left;
        padding-left: 84px;
        width: 152px;
        border-top: 1px solid #f3f2f0;
        position: relative;
        border-left: 4px solid #fff;
        &.showList1 {
          margin-bottom: 140px;
        }
        .icon {
          width: 20px;
          height: 20px;
          position: absolute;
          left: 56px;
          top: 19px;
        }

        .accBind {
          background: url("../../assets/images/icons.png") no-repeat -267px -48px;
        }
        .safetyCenter {
          background: url("../../assets/images/icons.png") no-repeat -267px -78px;
        }
        .menberCenter {
          background: url("../../assets/images/icons.png") no-repeat -267px -108px;
        }
        .commentMan {
          background: url("../../assets/images/icons.png") no-repeat -267px -138px;
        }
        ul.sub-menu {
          position: absolute;
          top: 60px;
          width: 200px;
          left: 36px;
          text-align: left;
          li {
            padding-left: 48px;
            font-weight: 400;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            position: relative;
            border: 0;
            + li {
              border-top: 1px solid #f3f2f0;
            }
            .sub-icon {
              width: 6px;
              height: 6px;
              position: absolute;
              left: 34px;
              top: 17px;
              background: url("../../assets/images/icons.png") no-repeat -315px -55px;
              // background-size: 450px auto;
            }
          }
          li.active {
            font-weight: 700;
            .sub-icon {
              background: url("../../assets/images/icons.png") no-repeat -315px -85px;
            }
          }
        }
      }
      > li.active {
        + li {
          border-top: 1px solid #f3f2f0;
        }
        border-top: 1px solid #f3f2f0;
        background-color: #f3f2f0;
        font-weight: 700;
        border-left: 4px solid #f98c81;
        .accBind {
          background: url("../../assets/images/icons.png") no-repeat -227px -48px;
        }
        .safetyCenter {
          background: url("../../assets/images/icons.png") no-repeat -227px -78px;
        }
        .menberCenter {
          background: url("../../assets/images/icons.png") no-repeat -227px -108px;
        }
        .commentMan {
          background: url("../../assets/images/icons.png") no-repeat -227px -138px;
        }
      }
      > li:hover {
        // font-weight: 700;
        // background: #1161d1;
        // cursor: pointer;
        // .item-label {
        //   color: #fff;
        // }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/sidebar.vue